import { INavData } from '@coreui/angular';
import { User as RUser } from './interfaces/user';
import { environment } from "../environments";

export const DOWNLOAD_LOGS_HREF = '#download-logs';

interface User extends RUser {
  slots: number;
}

export const navItems: (INavData & { role?: string[], filter?: (user: User) => boolean, i18nkey?: string, isFree: boolean })[] = [
  {
    name: 'Tournaments',
    i18nkey: 'tournaments',
    url: '/tournaments',
    icon: 'icon-globe',
    filter: (user) => !user.team || user.role.includes('MASTER'),
    isFree: true,
  },
  {
    name: 'Manage Schedules',
    i18nkey: 'manage_schedules',
    url: '/scheduled-tournaments',
    icon: 'icon-calendar',
    isFree: true,
  },
  {
    name: 'Rebalance Schedule',
    i18nkey: 'rebalance_schedule',
    url: '/rebalance',
    icon: 'fa fa-balance-scale',
    role: ['MASTER'],
    isFree: false,
  },
  {
    name: 'Manage Filters',
    i18nkey: 'manage_filters',
    url: '/manage-filters',
    icon: 'fa fa-filter',
    role: ['MASTER'],
    isFree: false,
  },
  {
    name: 'Approve Tournaments',
    i18nkey: 'approve_tournaments',
    url: '/approve-tournaments',
    icon: 'fa fa-bullhorn',
    role:['MASTER'],
    filter: (user) => (!user.team || user.role.includes('MASTER')) && (user.user_count > 1 || user.slots > 1),
    isFree: false,
  },
  {
    name: 'Tournament Requests',
    i18nkey: 'tournament_requests',
    url: '/requested-tournaments',
    icon: 'fa fa-envelope-open-o',
    isFree: false,
  },
  {
    name: 'Team Global Settings',
    i18nkey: 'team_global_settings',
    url: '/team-global-settings',
    icon: 'fa fa-cogs',
    role: ['MASTER'],
    isFree: false,
  },
  {
    name: 'Manage Team',
    i18nkey: 'manage_team',
    url: '/my-team',
    icon: 'icon-people',
    role: ['MASTER'],
    filter: (user) => user.user_count > 1 || user.slots > 1,
    isFree: false,
  },
  {
    name: 'Manage Users',
    i18nkey: 'manage_users',
    url: '/owner-manage-users',
    icon: 'icon-people',
    role: ['OWNER'],
    filter: (user) => user.user_count > 1 || user.slots > 1,
    isFree: false,
  },
  {
    name: 'Add Tournaments',
    i18nkey: 'add_tournaments',
    url: '/add-tournaments-tier',
    icon: 'icon-note',
    role: ['MASTER'],
    isFree: false
  },
  {
    name: 'Manage Logs',
    i18nkey: 'manage_logs',
    url: '/manage-logs',
    icon: 'fa fa-file-text-o',
    role: ['MASTER'],
    isFree: false,
  },
  /* {
    name: 'Tournament Qualifiers',
    i18nkey: 'tournament_level_config',
    url: '/level-config',
    icon: 'fa fa-line-chart',
    role: ['MASTER'],
    isFree: false,
  }, */
  {
    name: 'User Profile',
    i18nkey: 'user_profile',
    url: '/user-profile',
    icon: 'icon-user',
    isFree: false,
  },
  {
    title: true,
    name: 'Admin',
    i18nkey: 'admin',
    role: ['TA', 'SA'],
    isFree: false,
  },
  {
    name: 'Add Tournaments',
    i18nkey: 'add_tournaments',
    url: '/add-tournaments',
    icon: 'icon-note',
    role: ['TA', 'SA'],
    isFree: false
  },
  {
    name: 'Manage Sites & Tags',
    i18nkey: 'manage_sites_tags',
    url: '/manage-sites',
    icon: 'icon-tag',
    role: ['TA', 'SA'],
    isFree: false
  },
  {
    name: 'Manage Brands',
    i18nkey: 'manage_brands',
    url: '/manage-brands',
    icon: 'icon-tag',
    role: ['TA', 'SA'],
    isFree: false
  },
  {
    name: 'Manage Series',
    i18nkey: 'manage_series',
    url: '/manage-series',
    icon: 'icon-tag',
    role: ['TA', 'SA'],
    isFree: false
  },
  {
    name: 'Manage Users',
    i18nkey: 'manage_users',
    url: '/manage-users',
    icon: 'icon-people',
    role: ['SA'],
    isFree: false
  },
  {
    name: 'Manage Teams',
    i18nkey: 'manage_teams',
    url: '/manage-teams',
    icon: 'icon-people',
    role: ['SA'],
    isFree: false
  },
  {
    name: 'Manage Structures',
    i18nkey: 'manage_structures',
    url: '/manage-structures',
    icon: 'icon-layers',
    role: ['TA', 'SA'],
    isFree: false
  },
  {
    name: 'Miner Reports',
    i18nkey: 'miner_reports',
    url: '/miner-reports',
    icon: 'fa fa-database',
    role: ['TA', 'SA'],
    isFree: false
  },
  {
    name: 'Job Metrics',
    i18nkey: 'job_metrics',
    url: '/job-metrics',
    icon: 'fa fa-line-chart',
    role: ['TA', 'SA'],
    isFree: false
  },
  {
    name: 'Site Config',
    url: '/manage-ads',
    icon: 'icon-frame',
    role: ['TA', 'SA'],
    isFree: false
  },
  {
    title: true,
    name: 'User',
    i18nkey: 'user',
    isFree: false
  },
  {
    name: 'Manage Bankroll',
    i18nkey: 'manage_bankroll',
    url: '/bankroll',
    icon: 'icon-graph',
    isFree: true
  },
  {
    name: 'All Time Reports',
    i18nkey: 'play_reports',
    url: '/stats',
    icon: 'icon-chart',
    isFree: false
  },
  {
    name: 'Notifications',
    i18nkey: 'notifications',
    url: '/notifications',
    icon: 'icon-bell',
    isFree: false
  },
  {
    title: true,
    name: 'Downloads',
    i18nkey: 'downloads',
    role: ['SA'],
    isFree: false
  },
  {
    name: 'Download Logs',
    i18nkey: 'download_logs',
    url: '#',
    // The default layout intercepts this link and downloads through HttpClient.
    href: DOWNLOAD_LOGS_HREF,
    icon: 'icon-book-open',
    role: ['SA'],
    isFree: false
  },
]
